var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('FeedbackModal'),_c('div',{attrs:{"id":"default-layout"}},[_c('Menu',{class:{'hide-on-desktop': _vm.isLoginPage()}}),_c('div',{class:{'full-width': _vm.isLoginPage()},attrs:{"id":"root"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }